export default {
  permissions: `/v1/permissions/permissions`,
  permission: (id: string) => `/v1/permissions/permissions/${id}`
};
